import Home from "./pages/home/Home";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useContext } from 'react';
import { Login } from "./pages/login/Login";
import { ForgotPwd } from "./pages/forgotPwd/ForgotPwd"

import NotificationList from "./pages/notifications/list/List";
import NotificationSingle from "./pages/notifications/single/Single";
import NotificationNew from "./pages/notifications/new/New"; 

import ReviewsList from "./pages/reviews/list/List";
import ReviewsSingle from "./pages/reviews/single/Single";

import SettingsList from "./pages/settings/list/List";
import SettingsSingle from "./pages/settings/single/Single";
import SettingsNew from "./pages/settings/new/New"; 
import SettingsEdit from "./pages/settings/edit/Edit"

import MessagesList from "./pages/messages/list/List";
import MessagesSingle from "./pages/messages/single/Single";
import MessagesNew from "./pages/messages/new/New"; 

import { notificationInput, settingsInput, applicantInput, chargesInput, messagesInput} from "./data/formSource";
import './style/dark.scss'
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";

import ApplicantList from "./pages/visaApplicant/list/List"
import ApplicantSingle from "./pages/visaApplicant/single/Single"
import ApplicantNew from "./pages/visaApplicant/new/New"

import ApplicationList from "./pages/visaApplication/list/List"
import ApplicationSingle from "./pages/visaApplication/single/Single"

import ApplicationHistoryList from "./pages/applicationHistory/list/List"
import ApplicationHistorySingle from "./pages/applicationHistory/single/Single"

import ChargesList from "./pages/charges/list/List"
import ChargesNew from "./pages/charges/new/New"
import ChargesSingle from "./pages/charges/single/Single"
import ChargesEdit from "./pages/charges/edit/Edit"


import NairaChargesList from "./pages/nairaCharges/list/List"
import NairaChargesNew from "./pages/nairaCharges/new/New"
import NairaChargesSingle from "./pages/nairaCharges/single/Single"
import NairaChargesEdit from "./pages/nairaCharges/edit/Edit"

import DollarChargesList from "./pages/dollarCharges/list/List"
import DollarChargesNew from "./pages/dollarCharges/new/New"
import DollarChargesSingle from "./pages/dollarCharges/single/Single"
import DollarChargesEdit from "./pages/dollarCharges/edit/Edit"

import PaymentList from './pages/visaPayments/list/List'
import PaymentSingle from './pages/visaPayments/single/Single'

import DollarPaymentList from './pages/dollarPayments/list/List'
import NairaPaymentList from './pages/nairaPayments/list/List'

import ContactList from "./pages/contact/list/List"
import ContactNew from "./pages/contact/new/New"
import ContactSingle from "./pages/contact/single/Single"

import AnnouncementList from "./pages/announcement/list/List"
import AnnouncementNew from "./pages/announcement/new/New"
import AnnouncementSingle from "./pages/announcement/single/Single"
import AnnouncementEdit from "./pages/announcement/edit/Edit"







function App() {
  
  const { darkMode } = useContext(DarkModeContext)
  const { currentUser } = useContext(AuthContext)

  const RequireAuth = ({children}) => {
    return currentUser ? children : <Navigate to="/login"/>
  }

  return (
    <div className= {darkMode ? "app dark" : "app"}>
       <BrowserRouter>
        <Routes>
          <Route path="/">
          <Route path="login" element={<Login/>}/>
          <Route path="forgotPwd" element={<ForgotPwd/>}/>
            <Route index element={
            <RequireAuth>
                 <Home user={currentUser}/>
            </RequireAuth>
            
           } />


            {/* <Route path="dollarList">
              <Route index element={
                <RequireAuth>
                 <DollarList />
              </RequireAuth>
              }/>
             
            </Route>


            <Route path="nairaList">
              <Route index element={
                <RequireAuth>
                 <NairaList />
              </RequireAuth>
              }/>
             
            </Route> */}


            <Route path="applicants">
              <Route index element={
                <RequireAuth>
                 <ApplicantList />
              </RequireAuth>
              }/>
              <Route path=":applicantId" element={
              <RequireAuth>
                  <ApplicantSingle/>
              </RequireAuth>
              
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <ApplicantNew inputs={applicantInput} title="Add New Applicant"/>
                </RequireAuth>
              }/>
            </Route>

            <Route path="applications">
              <Route index element={
                <RequireAuth>
                  <ApplicationList/>
                </RequireAuth>
              }/>
              <Route path=":applicationId" element={
              <RequireAuth>
                  <ApplicationSingle/>
              </RequireAuth>
              }/>
            
            </Route>

            <Route path="applicationHistory">
              <Route index element={
                <RequireAuth>
                  <ApplicationHistoryList/>
                </RequireAuth>
              }/>
              <Route path=":applicationHistoryId" element={
              <RequireAuth>
                  <ApplicationHistorySingle/>
              </RequireAuth>
              }/>
            
            </Route>
            

            <Route path="charges">
              <Route index element={
                <RequireAuth>
                  <ChargesList/>
                </RequireAuth>
              }/>

              <Route path="new" element={
              <RequireAuth>
                  <ChargesNew/>
              </RequireAuth>
              }/>

              <Route path=":chargesId" element={
              <RequireAuth>
                  <ChargesSingle/>
              </RequireAuth>
              }/>

              <Route path="edit/:chargeId" element={
                <RequireAuth>
                  <ChargesEdit inputs={chargesInput} title="Edit Charges"/>
                </RequireAuth>
              }/>
            
            </Route>


            <Route path="dollarCharges">

              <Route index element={
                <RequireAuth>
                  <DollarChargesList/>
                </RequireAuth>
              }/>
              <Route path=":dollarChargeId" element={
              <RequireAuth>
                  <DollarChargesSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <DollarChargesNew title="Add Dollar Charges"/>
                </RequireAuth>
              }/>

               <Route path="edit/:dollarChargeId" element={
                <RequireAuth>
                  <DollarChargesEdit/>
                </RequireAuth>
              }/>
            
            </Route>

            
            <Route path="nairaCharges">

              <Route index element={
                <RequireAuth>
                  <NairaChargesList/>
                </RequireAuth>
              }/>
              <Route path=":nairaChargeId" element={
              <RequireAuth>
                  <NairaChargesSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <NairaChargesNew title="Add Naira Charges"/>
                </RequireAuth>
              }/>

               <Route path="edit/:nairaChargeId" element={
                <RequireAuth>
                  <NairaChargesEdit/>
                </RequireAuth>
              }/>
            
            </Route>


            <Route path="dollarPayments">
              <Route index element={
                <RequireAuth>
                  <DollarPaymentList/>
                </RequireAuth>
              }/>
              <Route path=":paymentId" element={
              <RequireAuth>
                  <PaymentSingle/>
              </RequireAuth>
              }/>

            </Route>

            <Route path="nairaPayments">
              <Route index element={
                <RequireAuth>
                  <NairaPaymentList/>
                </RequireAuth>
              }/>
              <Route path=":paymentId" element={
              <RequireAuth>
                  <PaymentSingle/>
              </RequireAuth>
              }/>

            </Route>
          
            </Route>
         
            
            <Route path="notifications">
              <Route index element={
               <RequireAuth>
                <NotificationList />
               </RequireAuth>
              }/>
              <Route path=":notificationId" element={
                <RequireAuth>
                 <NotificationSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <NotificationNew inputs={notificationInput} title="Add New Dish"/>
                </RequireAuth>
              }/>
            </Route>

            <Route path="announcement">
              <Route index element={
               <RequireAuth>
                <AnnouncementList />
               </RequireAuth>
              }/>
              <Route path=":announcementId" element={
                <RequireAuth>
                 <AnnouncementSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <AnnouncementNew inputs={notificationInput} title="Add New Announcement"/>
                </RequireAuth>
              }/>
               <Route path="edit/:announcementId" element={
                <RequireAuth>
                  <AnnouncementEdit/>
                </RequireAuth>
              }/>
            </Route>

            <Route path="reviews">
              <Route index element={
               <RequireAuth>
                <ReviewsList />
               </RequireAuth>
              }/>
              <Route path=":reviewId" element={
                <RequireAuth>
                 <ReviewsSingle/>
                </RequireAuth>
              }/>
            
            </Route>

            <Route path="settings">
                <Route index element={
                <RequireAuth>
                  <SettingsList />
                </RequireAuth>
                }/>
                <Route path=":settingsId" element={
                  <RequireAuth>
                  <SettingsSingle/>
                  </RequireAuth>
                }/>
                <Route path="new" element={
                  <RequireAuth>
                    <SettingsNew inputs={settingsInput} title="Add Settings"/>
                  </RequireAuth>
                }/>
                <Route path="edit/:settingsId" element={
                <RequireAuth>
                  <SettingsEdit/>
                </RequireAuth>
              }/>
            </Route>

            <Route path="messages">
            <Route index element={
              <RequireAuth>
              <MessagesList />
              </RequireAuth>
            }/>
            <Route path=":messagesId" element={
              <RequireAuth>
                <MessagesSingle/>
              </RequireAuth>
            }/>
            <Route path="new" element={
              <RequireAuth>
                <MessagesNew inputs={messagesInput} title="Add New Message"/>
              </RequireAuth>
            }/>
            </Route>

            <Route path="contacts">
              <Route index element={
                <RequireAuth>
                 <ContactList />
              </RequireAuth>
              }/>
              <Route path=":contactId" element={
              <RequireAuth>
                  <ContactSingle/>
              </RequireAuth>
              
              }/>
            </Route>

        </Routes>
  </BrowserRouter>
    </div>
  );
}

export default App;































// import Home from "./pages/home/Home";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import { useContext } from 'react';
// import { Login } from "./pages/login/Login";
// import { ForgotPwd } from "./pages/forgotPwd/ForgotPwd"
// import CustomerList from './pages/customers/list/List'
// import CustomerSingle from './pages/customers/single/Single'
// import SubscribersList from './pages/subscribers/list/List'
// import SubscribersSingle from './pages/subscribers/single/Single'
// import OutletsList from './pages/outlets/list/List'
// import OutletsSingle from './pages/outlets/single/Single'
// import PaymentsList from './pages/payments/list/List'
// import PaymentsSingle from './pages/payments/single/Single'
// import StaffList from "./pages/staff/list/List";
// import StaffSingle from "./pages/staff/single/Single";
// import StaffNew from "./pages/staff/new/New"; 
// import StaffEdit from "./pages/staff/edit/Edit";
// import NotificationList from "./pages/notifications/list/List";
// import NotificationSingle from "./pages/notifications/single/Single";
// import NotificationNew from "./pages/notifications/new/New"; 
// import ReviewsList from "./pages/reviews/list/List";
// import ReviewsSingle from "./pages/reviews/single/Single";
// import AnalythicsList from "./pages/analythics/list/List";
// import AnalythicsSingle from "./pages/analythics/single/Single";
// import AnalythicsNew from "./pages/analythics/new/New"; 
// import SettingsList from "./pages/settings/list/List";
// import SettingsSingle from "./pages/settings/single/Single";
// import SettingsNew from "./pages/settings/new/New"; 
// import SettingsEdit from "./pages/settings/edit/Edit";
// import PaymentList from "./pages/payments/list/List";
// import PaymentSingle from "./pages/payments/single/Single";
// import ProfileSingle from "./pages/profile/single/Single";
// import MessageList from "./pages/messages/list/List";
// import MessageSingle from "./pages/messages/single/Single";
// import MessageNew from "./pages/messages/new/New"; 

// import IndividualList from "./pages/individual/list/List";
// import IndividualSingle from "./pages/individual/single/Single";
// import IndividualNew from "./pages/individual/new/New"; 

// import GroupList from "./pages/group/list/List";
// import GroupSingle from "./pages/group/single/Single";
// import GroupNew from "./pages/group/new/New"; 

// import { staffInput, notificationInput, settingsInput} from "./data/formSource";
// import './style/dark.scss'
// import { DarkModeContext } from "./context/darkModeContext";
// import { AuthContext } from "./context/AuthContext";
// import OutletEdit from "./pages/outlets/edit/Edit";


// import PaidList from './pages/paid/list/List'
// import PaidSingle from './pages/paid/single/Single'
// import PaidEdit from "./pages/paid/edit/Edit";

// import UnPaidList from './pages/unpaid/list/List'
// import UnPaidSingle from './pages/unpaid/single/Single'
// import UnPaidEdit from "./pages/unpaid/edit/Edit";

// import ReleaseList from "./pages/releases/list/List";
// import ReleaseSingle from "./pages/releases/single/Single";
// import ReleaseNew from "./pages/releases/new/New"; 


// import AdvertList from "./pages/adverts/list/List";
// import AdvertSingle from "./pages/adverts/single/Single";
// import AdvertNew from "./pages/adverts/new/New"; 
// import AdvertEdit from "./pages/adverts/edit/Edit";


// import EventsList from "./pages/events/list/List";
// import EventsSingle from "./pages/events/single/Single";
// // import EventsNew from "./pages/events/new/New"; 
// import EventsEdit from "./pages/events/edit/Edit";



// function App() {
  
//   const { darkMode } = useContext(DarkModeContext)
//   const { currentUser } = useContext(AuthContext)

//   const RequireAuth = ({children}) => {
//     return currentUser ? children : <Navigate to="/login"/>
//   }

//   return (
//     <div className= {darkMode ? "app dark" : "app"}>
//        <BrowserRouter>
//         <Routes>
//           <Route path="/">
//           <Route path="login" element={<Login/>}/>
//           <Route path="forgotPwd" element={<ForgotPwd/>}/>
//             <Route index element={
//             <RequireAuth>
//                  <Home user={currentUser}/>
//             </RequireAuth>
            
//            } />

//             <Route path="customers">
//               <Route index element={
//                 <RequireAuth>
//                  <CustomerList/>
//               </RequireAuth>
//               }/>
//               <Route path=":customerId" element={
//               <RequireAuth>
//                   <CustomerSingle/>
//               </RequireAuth>
              
//               }/>
            
//             </Route>


//             <Route path="subscribers">
//               <Route index element={
//                 <RequireAuth>
//                  <SubscribersList/>
//               </RequireAuth>
//               }/>
//               <Route path=":subscriberId" element={
//               <RequireAuth>
//                   <SubscribersSingle/>
//               </RequireAuth>
              
//               }/>
             
//             </Route>

//             <Route path="outlets">
//               <Route index element={
//                 <RequireAuth>
//                  <OutletsList/>
//               </RequireAuth>
//               }/>
//               <Route path=":outletId" element={
//               <RequireAuth>
//                   <OutletsSingle/>
//               </RequireAuth>
              
//               }/>
//               <Route path="/outlets/edit/:outletId" element={
//               <RequireAuth>
//                   <OutletEdit/>
//               </RequireAuth>
              
//               }/>
            
//             </Route>


//              <Route path="paid">
//               <Route index element={
//                 <RequireAuth>
//                  <PaidList/>
//               </RequireAuth>
//               }/>
//               <Route path=":paidId" element={
//               <RequireAuth>
//                   <PaidSingle/>
//               </RequireAuth>
              
//               }/>
//               <Route path="/paid/edit/:paidId" element={
//               <RequireAuth>
//                   <PaidEdit/>
//               </RequireAuth>
              
//               }/>
            
//             </Route>


//             <Route path="unpaid">
//               <Route index element={
//                 <RequireAuth>
//                  <UnPaidList/>
//               </RequireAuth>
//               }/>
//               <Route path=":unpaidId" element={
//               <RequireAuth>
//                   <UnPaidSingle/>
//               </RequireAuth>
              
//               }/>
//               <Route path="/unpaid/edit/:unpaidId" element={
//               <RequireAuth>
//                   <UnPaidEdit/>
//               </RequireAuth>
              
//               }/>
            
//             </Route>

//               <Route path="group">
//               <Route index element={
//                 <RequireAuth>
//                   <GroupList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":groupId" element={
//               <RequireAuth>
//                   <GroupSingle/>
//               </RequireAuth>
//               }/>

//             <Route path="new" element={
//                 <RequireAuth>
//                   <GroupNew title="Add New Group Notification"/>
//                 </RequireAuth>
//               }/>

//               </Route>

//               <Route path="individual">
//               <Route index element={
//                 <RequireAuth>
//                   <IndividualList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":individualId" element={
//               <RequireAuth>
//                   <IndividualSingle/>
//               </RequireAuth>
//               }/>

//             <Route path="new" element={
//                 <RequireAuth>
//                   <IndividualNew title="Add New Individual Notification"/>
//                 </RequireAuth>
//               }/>

//             </Route>


//             <Route path="releases">
//               <Route index element={
//                 <RequireAuth>
//                   <ReleaseList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":releaseId" element={
//               <RequireAuth>
//                   <ReleaseSingle/>
//               </RequireAuth>
//               }/>

//             <Route path="new" element={
//                 <RequireAuth>
//                   <ReleaseNew title="Add New Future Releases"/>
//                 </RequireAuth>
//               }/>

//             </Route>


//             <Route path="payments">
//               <Route index element={
//                 <RequireAuth>
//                  <PaymentsList/>
//               </RequireAuth>
//               }/>
//               <Route path=":paymentId" element={
//               <RequireAuth>
//                   <PaymentsSingle/>
//               </RequireAuth>
              
//               }/>
           
//             </Route>


//             <Route path="messages">
//               <Route index element={
//                 <RequireAuth>
//                   <MessageList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":messageId" element={
//               <RequireAuth>
//                   <MessageSingle/>
//               </RequireAuth>
//               }/>

//             <Route path="new" element={
//                 <RequireAuth>
//                   <MessageNew title="Add New Message"/>
//                 </RequireAuth>
//               }/>

//             </Route>


//             <Route path="analythics">
//               <Route index element={
//                 <RequireAuth>
//                   <AnalythicsList/>
//                 </RequireAuth>
//               }/> 
//             <Route path=":analyticId" element={
//               <RequireAuth>
//                   <AnalythicsSingle/>
//               </RequireAuth>
//               }/> 

//             <Route path="new" element={
//                 <RequireAuth>
//                   <AnalythicsNew title="Add New Analytic"/>
//                 </RequireAuth>
//               }/>

//             </Route>
              
//              <Route path="staff">
//               <Route index element={
//                <RequireAuth>
//                 <StaffList />
//                </RequireAuth>
//               }/>
//               <Route path=":staffId" element={
//                 <RequireAuth>
//                  <StaffSingle/>
//                 </RequireAuth>
//               }/>
//               <Route path="new" element={
//                 <RequireAuth>
//                   <StaffNew inputs={staffInput} title="Add New Staff"/>
//                 </RequireAuth>
//               }/>
//               <Route path="/staff/edit/:staffId" element={
//               <RequireAuth>
//                   <StaffEdit/>
//               </RequireAuth>
              
//               }/>
//               </Route>

//              <Route path="settings">
//               <Route index element={
//                <RequireAuth>
//                 <SettingsList />
//                </RequireAuth>
//               }/>
//               <Route path=":settingsId" element={
//                 <RequireAuth>
//                  <SettingsSingle/>
//                 </RequireAuth>
//               }/>
//               <Route path="new" element={
//                 <RequireAuth>
//                   <SettingsNew inputs={settingsInput} title="Add Settings"/>
//                 </RequireAuth>
//               }/>
//               <Route path="/settings/edit/:settingsId" element={
//               <RequireAuth>
//                   <SettingsEdit/>
//               </RequireAuth>
              
//               }/>
//               </Route>

//             </Route>
      
//             <Route path="notifications">
//               <Route index element={
//                <RequireAuth>
//                 <NotificationList />
//                </RequireAuth>
//               }/>
//               <Route path=":notificationId" element={
//                 <RequireAuth>
//                  <NotificationSingle/>
//                 </RequireAuth>
//               }/>
//               <Route path="new" element={
//                 <RequireAuth>
//                   <NotificationNew inputs={notificationInput} title="Add New Notification"/>
//                 </RequireAuth>
//               }/>
//             </Route>
//             <Route path="reviews">
//               <Route index element={
//                <RequireAuth>
//                 <ReviewsList />
//                </RequireAuth>
//               }/>
//               <Route path=":reviewId" element={
//                 <RequireAuth>
//                  <ReviewsSingle/>
//                 </RequireAuth>
//               }/>
            
//               </Route>

//             <Route path="payments">
//               <Route index element={
//                 <RequireAuth>
//                   <PaymentList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":paymentId" element={
//               <RequireAuth>
//                   <PaymentSingle/>
//               </RequireAuth>
//               }/>
            
//             </Route>

//             <Route path=":profileId">
//               <Route index element={
//                 <RequireAuth>
//                   <ProfileSingle/>
//                 </RequireAuth>
               
//               }/>
//             </Route>


//             <Route path="adverts">
//               <Route index element={
//                 <RequireAuth>
//                   <AdvertList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":advertId" element={
//               <RequireAuth>
//                   <AdvertSingle/>
//               </RequireAuth>
//               }/>

//               <Route path="new" element={
//                 <RequireAuth>
//                   <AdvertNew title="Add New Advert"/>
//                 </RequireAuth>
//               }/>

//               <Route path="/adverts/edit/:advertId" element={
//               <RequireAuth>
//                   <AdvertEdit/>
//               </RequireAuth>
              
//               }/>

//             </Route>

//               <Route path="events">
//               <Route index element={
//                 <RequireAuth>
//                   <EventsList/>
//                 </RequireAuth>
//               }/>
//               <Route path=":eventsId" element={
//               <RequireAuth>
//                   <EventsSingle/>
//               </RequireAuth>
//               }/>

//               <Route path="/events/edit/:eventsId" element={
//               <RequireAuth>
//                   <EventsEdit/>
//               </RequireAuth>
              
//               }/>

//             {/* <Route path="new" element={
//                 <RequireAuth>
//                   <EventsNew title="Add New Advert"/>
//                 </RequireAuth>
//               }/> */}

//             </Route>

//         </Routes>
//   </BrowserRouter>
//     </div>
//   );
// }

// export default App;
